import { AccessForbiddenPage } from '@openx/components-core/lib/AccessForbiddenBackPage/AccessForbiddenPage';
import { ProviderDetails } from '@openx/components-provider/lib/components/ProviderDetails/ProviderDetails';
import type { ProvidersRouteParams } from '@openx/components-provider/lib/components/types';
import { useCallback, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router';
import { useAuth } from '../../components/AuthContext/context';
import { isAdmin } from '../../permissions/validators';
import { listSearchParams } from '../../utils/useListCriteria';

export const ProviderDetailsPage = () => {
  const { session } = useAuth();
  const { providerId = '' } = useParams<ProvidersRouteParams>();
  const navigate = useNavigate();
  const isAllowed = useMemo(() => isAdmin(session), [session]);

  const handleGoBack = useCallback(() => {
    navigate(`/providers?${listSearchParams.providers ?? ''}`);
  }, [navigate]);

  if (!isAllowed) return <AccessForbiddenPage />;

  return <ProviderDetails handleGoBack={handleGoBack} providerId={providerId} titlePrefix="OpenXSelect" />;
};
